export default __webpack_public_path__ + "static/media/order-step1.070371e8.svg";